import { render } from "./DashboardActivityFeed.vue?vue&type=template&id=9ab0a044"
import script from "./DashboardActivityFeed.vue?vue&type=script&lang=js"
export * from "./DashboardActivityFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__